export default __webpack_public_path__ + "static/media/i-boleto.3ebe0f30.png";